import React, { ChangeEvent } from "react";

import { Input, FormControl } from "kanopi-components/Input";

import { WidthContainer } from "../../ChatFlow/WidthContainer";

interface StringInputProps {
  label: string;
  title?: string;
  help?: string;
  error?: string;
  hideLabel?: boolean;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const StringInput = ({
  label,
  title,
  help,
  error,
  hideLabel,
  ...props
}: StringInputProps) => {
  return (
    <WidthContainer>
      <FormControl
        label={label}
        title={title}
        caption={help}
        error={error}
        hideLabel={hideLabel}
      >
        <Input {...props} />
      </FormControl>
    </WidthContainer>
  );
};
